<template>
  <div class="viewDashBoard" v-cloak>
    <div class="container">
      <div
        v-if="
          typeof getActiveUserData.user !== 'undefined' &&
            Object.keys(getActiveUserData.user).length
        "
      >
        <adminvue-dashboard-vue
          v-if="
            getActiveUserData.userRoles == 'admin' ||
              getActiveUserData.userRoles == 'salesmanager' ||
              getActiveUserData.userRoles == 'salesteamlead' ||
              getActiveUserData.userRoles == 'salesperson'
          "
        ></adminvue-dashboard-vue>
        <default-dashboard-vue v-else></default-dashboard-vue>
      </div>
      <div v-else class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adminvue from "./components/admin_dashboard";
import default_vue from "./components/default_dashboard";

export default {
  components: {
    "adminvue-dashboard-vue": adminvue,
    "default-dashboard-vue": default_vue
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  data() {
    return {};
  },
  mounted() {
    document.title =
      "PNC Work Bench - " + this.$router.app._route.meta.pageTitle;
  },
  methods: {}
};
</script>
